import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithIsHome, WithTeam } from '~/core/styleTypes';

import { WithIsShowingGameLinks } from '../../../gameOrSeriesScoreboard/styles';
import { getScoreboardDecoratorBorderRadius } from '../../../gameOrSeriesScoreboard/utils';
import { SIZING } from '../stylizedTeam/styles';

export const DecoratorContainer = styled.span<
    WithIsHome &
        WithIsShowingGameLinks &
        WithTeam & {
            $flipImage: boolean;
            $isExtraLarge: boolean;
            $isExpanded: boolean;
        }
>`
    height: ${({ $isExtraLarge, $isExpanded }) =>
        $isExtraLarge && !$isExpanded ? `${SIZING.trapezoidHeight}px` : `${SIZING.height}px`};
    max-width: 100px;
    overflow: hidden;
    transform: ${({ $flipImage }) => ($flipImage ? 'scaleX(-1) scaleY(-1)' : 'initial')};
    border-radius: ${({ $isExpanded, $isHome, $isShowingGameLinks }) =>
        getScoreboardDecoratorBorderRadius($isExpanded, $isHome, $isShowingGameLinks)};
    margin-left: ${({ $isExpanded }) => ($isExpanded ? '-3px' : '0')};

    ${BaseStyle.Mixins.screenSizes.smallerThanMedium} {
        display: none;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        min-width: 96px;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        max-width: 162px;
        min-width: 162px;
    }
`;

export const Trapezoid = styled.svg<WithTeam>`
    width: 190px;
    height: ${SIZING.height}px;

    fill: ${({ $teamAbbrev, theme }) =>
        ($teamAbbrev && theme.Team[$teamAbbrev]?.gamecenter) || theme.Surface.Opposite.tertiary};
`;

export const PositioningContainer = styled.span`
    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-left: ${-1 * SIZING.shapeMedium}px;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        margin-left: 0;
    }
`;

export const Triangle = styled.svg<WithIsHome & WithTeam & WithIsShowingGameLinks & { $isExpanded: boolean }>`
    border-radius: ${({ $isExpanded, $isHome, $isShowingGameLinks }) =>
        $isExpanded || ($isShowingGameLinks && $isHome) ? '0' : '3px'};
    height: ${SIZING.height}px;
    width: 72px;
    margin-bottom: -1px;
    margin-left: ${SIZING.shapeMedium}px;
    fill: ${({ $teamAbbrev, theme }) =>
        ($teamAbbrev && theme.Team[$teamAbbrev]?.gamecenter) || theme.Surface.Opposite.tertiary};
`;

export const Stripe = styled.svg<WithIsHome & WithTeam>`
    fill: none;
    height: ${SIZING.height}px;
    width: 115px;
    ${({ $isHome }) => ($isHome ? 'margin-right' : 'margin-left')}: ${-1 * SIZING.bigStripe}px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        fill: ${({ $teamAbbrev, theme }) =>
            ($teamAbbrev && theme.Team[$teamAbbrev]?.gamecenter) || theme.Surface.Opposite.tertiary};
        ${({ $isHome }) => ($isHome ? 'margin-right' : 'margin-left')}: ${-1 * SIZING.stripe}px;
    }
`;
